export default{sources:{avif:"__VITE_ASSET__Vl1nPx3k__ 400w",webp:"__VITE_ASSET__CLNH_wwn__ 400w"},img:{src:"__VITE_ASSET__D9sjf3XQ__",w:400,h:560}};